import React from "react";
import styled from "styled-components";

const Wrapper = styled.div`
    display: flex;
    /* justify-content: center; */
    align-items: center;
`;

const Content = styled.div`
    display: flex;
    flex-flow: column;
`;

const Title = styled.div`
    font-weight: ${({ theme }) => theme.fontWeight.bold};
`;

const Description = styled.div`
    font-weight: ${({ theme }) => theme.fontWeight.semiBold};
`;

const Image = styled.div`
    height: 48px;
    min-height: 48px;
    width: 48px;
    min-width: 48px;
    border-radius: 4px;
    background: #CCD9FA;
    margin-right: 12px;
`;

export const NameCell = () => {

    const title = 'Yotpo Loyalty redemption reminder'
    const description = 'Remind customers when they have enough points to redeem for a reward.'

    return (
        <Wrapper>
            <Image>
                image
            </Image>
            <Content>
                <Title>
                    {title}
                </Title>
                <Description>
                    {description}
                </Description>
            </Content>
        </Wrapper>
    )
}
